import { LOAD_ALL_PRODUCTS, LOAD_SINGLE_PRODUCT } from "./ProductsList.saga";

export const loadAllProducts = (payload) => ({
  type: LOAD_ALL_PRODUCTS.LOADING,
  payload,
});

export const loadSingleProduct = (payload) => ({
  type: LOAD_SINGLE_PRODUCT.LOADING,
  payload,
});
